import React from 'react';

const Offers = () => {
  return (
    <div className='max-w-[900px] m-auto px-4 py-12 flex flex-wrap justify-between'>
      <p className='text-lg font-bold text-gray-700'>Wall Painting</p>
      <p className='text-lg font-bold text-gray-700'>Home Packages</p>
      <p className='text-lg font-bold text-gray-700'>Renovation</p>
      <p className='text-lg font-bold text-gray-700'>Buy Colors</p>
    </div>
  );
};

export default Offers;
